import { Box, Card, CardHeader, CardBody, Heading, Text, Button } from '@chakra-ui/react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { EmailSoaForm } from '@/components/forms/EmailSoaForm'
import { shippingLineNameFromSearchParams } from '@/lib/navigation/financialStatementsSearchParams'

export default function EmailSoaToClientPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const params = useParams<{ shippingLineId: string; soaId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const soaIdFromParams = params.soaId ? parseInt(params.soaId, 10) : undefined

  const shippingLineName = shippingLineNameFromSearchParams(searchParams)
  const finalShippingLineId = paramsShippingLineId
  const finalSoaId = soaIdFromParams
  const validSoaId =
    typeof finalSoaId === 'number' && Number.isFinite(finalSoaId) ? finalSoaId : null

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Email Statement of Account to Client
            </Heading>
          </CardHeader>
          <CardBody>
            {validSoaId == null ? (
              <Box>
                <Text color={colors.textSecondary} mb={4}>
                  Invalid SOA. Cannot send email.
                </Text>
                <Button size="sm" variant="outline" onClick={handleCancel}>
                  Cancel
                </Button>
              </Box>
            ) : (
              <EmailSoaForm
                shippingLineName={shippingLineName}
                soaId={validSoaId}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            )}
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
